export default {
  'merchantManagement.title': '商户列表',
  'merchantManagement.form.merchantName': '商户名称',
  'merchantManagement.form.merchantName.placeholder': '请选择 商户名称',
  'merchantManagement.form.search': '查询',
  'merchantManagement.form.reset': '重置',
  'merchantManagement.operation.add': '新增',
  'merchantManagement.operation.delete': '删除',
  'merchantManagement.actions.refresh': '刷新',
  'merchantManagement.actions.density': '密度',
  'merchantManagement.actions.columnSetting': '列设置',
  'merchantManagement.columns.index': '#',
  'merchantManagement.columns.merchantName': '商户名称',
  'merchantManagement.columns.status': '状态',
  'merchantManagement.columns.createdAt': '创建时间',
  'merchantManagement.columns.updatedAt': '更新时间',
  'merchantManagement.columns.status.enabled': '启用',
  'merchantManagement.columns.status.disabled': '禁用',
  'merchantManagement.columns.operations': '操作',
  'merchantManagement.columns.operations.edit': '编辑',
  'merchantManagement.columns.operations.delete': '删除',
  'merchantManagement.columns.operations.deleteConfirm': '确定要删除这条记录吗？',
  'merchantManagement.size.mini': '迷你',
  'merchantManagement.size.small': '小',
  'merchantManagement.size.medium': '中',
  'merchantManagement.size.large': '大',
  'merchantManagement.modal.addTitle': '新增商户',
  'merchantManagement.modal.editTitle': '编辑商户',
  'merchantManagement.modal.merchantName': '商户名称',
  'merchantManagement.modal.merchantName.placeholder': '请输入商户名称',
  'merchantManagement.modal.merchantName.required': '请输入商户名称',
  'merchantManagement.modal.status': '状态',
  'merchantManagement.modal.status.enabled': '启用',
  'merchantManagement.modal.status.disabled': '禁用',
  'merchantManagement.modal.createSuccess': '创建成功',
  'merchantManagement.modal.createFailed': '创建失败',
  'merchantManagement.modal.updateSuccess': '更新成功',
  'merchantManagement.modal.updateFailed': '更新失败',
  'merchantManagement.operation.deleteSuccess': '删除成功',
  'merchantManagement.operation.deleteFailed': '删除失败',
  'merchantManagement.operation.noSelection': '请先选择要操作的商户',
  'merchantManagement.operation.batchDeleteConfirm': '确定要删除选中的商户吗？',
  'merchantManagement.operation.batchDeleteSuccess': '批量删除成功',
  'merchantManagement.operation.batchDeleteFailed': '批量删除失败',
};

